import m from "mithril";

import { GridViews } from "gridViews";

let GridModel = {
    vars: {
        gridEl: document.querySelector("[data-artists-grid]"),
        catId: 2,
        catName: null,
        requestUrl: null,
        data: null,
        gridDividerCount: 17,
        gridItemRandomPosLimit: 8,
        viewType: "grid",
        viewState: 1, // 1 = nav closed, 2 = nav open, 3 = grid/list active
        isArtistsPage: false,
        localStorageGridViewTypeName: "gridViewType",
        localStorageGridScrollPosName: "gridScrollPos",
        lazyloadClassnameArtists: "lazyload__artist",
    },

    init: (vnode) => {
        if (!GridModel.vars.gridEl) return;

        const dataConfig = JSON.parse(
            GridModel.vars.gridEl.getAttribute("data-artists-grid")
        );

        GridModel.vars = { ...GridModel.vars, ...dataConfig };

        GridModel.vars.viewState =
            vnode.attrs.viewState || GridModel.vars.viewState;
        GridModel.vars.catId = vnode.attrs.catId || GridModel.vars.catId;
        GridModel.vars.catName = vnode.attrs.catName || GridModel.vars.catName;
        GridModel.vars.viewType =
            GridModel.getLocalStorage(
                GridModel.vars.localStorageGridViewTypeName
            ) || GridModel.vars.viewType;

        GridModel.requestData();
    },

    requestData: () => {
        m.request({
            url: GridModel.vars.requestUrl,
        }).then((result) => {
            GridModel.vars.data = result;
            m.redraw();
        });
    },

    setGridImg: (imgs, imgFormat) => {
        let firstImgFormat = imgs[imgFormat][0];

        if (!firstImgFormat) {
            firstImgFormat =
                imgs[imgFormat == "landscape" ? "portrait" : "landscape"][0];
        }

        return firstImgFormat ? firstImgFormat.thumb : "";
    },

    getLocalStorage: (itemName) => {
        return localStorage.getItem(itemName);
    },

    setLocalStorage: (itemName, val) => {
        localStorage.setItem(itemName, val);
    },

    splitIntoSubArray: (arr, count) => {
        let newArray = [],
            counter = 0,
            itemsCount = Math.ceil(arr.length / count);
        for (var i = 0; i < itemsCount; i++) {
            newArray.push(arr.slice(counter, counter + count));
            counter = counter + count;
        }
        return newArray;
    },

    getBtnLabel: () => {
        switch (GridModel.vars.viewState) {
            case 2:
                return "schließen";
                break;

            case 3:
                return GridModel.vars.catName;
                break;

            default:
                if (GridModel.vars.isArtistsPage) {
                    return GridModel.vars.catName;
                }
                return "Künstler Kategorien";
        }
    },

    preloadImage: (url) => {
        // var img = new Image();
        // img.src = url;
    },

    setBodyScroll: () => {
        let bodyEl = document.body;
        if (GridModel.vars.viewState == 1) {
            bodyEl.setAttribute("data-scrolling", true);
        } else {
            bodyEl.setAttribute("data-scrolling", false);
        }
    },

    setImageFormatDataSrc: (el, clientData) => {
        let imgPreview = clientData.artist.artistPreviewImg,
            imgLandscape = GridModel.setGridImg(clientData.imgs, "landscape"),
            imgPortrait = GridModel.setGridImg(clientData.imgs, "portrait");
        if (imgPreview != "") {
            imgLandscape = imgPreview;
            imgPortrait = imgPreview;
        }
        el.setAttribute("data-src-landscape", imgLandscape);
        el.setAttribute("data-src-portrait", imgPortrait);
    },

    scrollToTop: () => {
        window.scrollTo(0, 0);
    },
};

export { GridModel };
